import styled from 'styled-components';

export const Content = styled.div``;

export const Div = styled.div``;

/**
 * The Orders cell — thumbnail then titles.
 *
 * `min-width: 0` on the text is what lets it clip instead of pushing the
 * thumbnail out of the cell: a flex item will not shrink below its content
 * width without it.
 */
export const OrderCell = styled.div`
  display: flex;
  align-items: center;
  gap: var(--s3);
  min-width: 0;
`;

export const OrderTitles = styled.div`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
